
export const PropertyFormData = {
  propertyName: '',
  propertyType: '', 
  description: '',
  address: '',
  city: '',
  state: '',
  pincode: '',
  landmark: '',
  latitude: '',
  longitude: '', 
  contactPerson: '',
  contactEmail: '',
  contactPhone: '',
  alternatePhone: '', 
  website: '', 
  totalArea: '', 
  yearEstablished: '', 
  numberOfFloors: null,
  checkInTime: '',
  checkOutTime: '',
  accommodations: [], 
  amenities: {
    general: [],
    recreational: [],
    dining: [],
    services: [],
  },
  cancellationPolicy: '',
  petPolicy: '', 
  smokingPolicy: '', 
  childPolicy: '',
  images: [],
  basePrice: null, 
  currency: '',
  specialFeatures: '', 
  nearbyAttractions: '', 
  accessibility: [], 
  languages: [],
  status: '',
};


export const exampleAccommodation = {
  id: '',
  type: '', 
  name: '',
  description: '',
  quantity: 0,
  maxOccupancy: 0,
  bedConfiguration: '',
  size: '', 
  pricePerNight: 0,
  amenities: [],
  images: [],
};

export const PROPERTY_TYPES = [
  { value: 'hotel', label: 'Hotel' },
  { value: 'homestay', label: 'Homestay' },
  { value: 'resort', label: 'Resort' },
  { value: 'farmstay', label: 'Farm Stay' },
  { value: 'villa', label: 'Villa' },
  { value: 'guesthouse', label: 'Guest House' },
  { value: 'cottage', label: 'Cottage' },
  { value: 'apartment', label: 'Apartment' },
   { value: 'hostel', label: 'Hostel' },
  { value: 'dormitory', label: 'Dormitory' },
];

export const ACCOMMODATION_TYPES = [
  { value: 'room', label: 'Room' },
  { value: 'cottage', label: 'Cottage' },
  { value: 'suite', label: 'Suite' },
  { value: 'villa', label: 'Villa' },
  { value: 'dormitory', label: 'Dormitory' },
  { value: 'tent', label: 'Tent' },
  { value: 'cabin', label: 'Cabin' },
  { value: 'apartment', label: 'Apartment' },
];

export const GENERAL_AMENITIES = [
  'WiFi',
  'Parking',
  'Air Conditioning',
  'Heating',
  'Power Backup',
  'CCTV Security',
  '24/7 Reception',
  'Elevator',
  'Wheelchair Accessible',
  'Luggage Storage',
];

export const RECREATIONAL_AMENITIES = [
  'Swimming Pool',
  'Gym/Fitness Center',
  'Spa',
  'Yoga/Meditation Area',
  'Kids Play Area',
  'Indoor Games',
  'Outdoor Games',
  'Library',
  'Garden',
  'Farm Activities',
  'Trekking',
  'Campfire',
  'BBQ Area',
  'Sports Court',
];

export const DINING_AMENITIES = [
  'Restaurant',
  'Bar',
  'Room Service',
  'Kitchen',
  'Breakfast Included',
  'Lunch Available',
  'Dinner Available',
  'In-room Dining',
  'Cafe',
  'Organic Food',
  'Multi-cuisine',
];

export const SERVICE_AMENITIES = [
  'Housekeeping',
  'Laundry Service',
  'Doctor on Call',
  'Concierge',
  'Tour Desk',
  'Car Rental',
  'Airport Transfer',
  'Railway Transfer',
  'Taxi Service',
  'Event Planning',
  'Conference Room',
  'Banquet Hall',
  'Business Center',
];

export const ROOM_AMENITIES = [
  'TV',
  'Mini Fridge',
  'Safe',
  'Tea/Coffee Maker',
  'Balcony',
  'Bathtub',
  'Shower',
  'Hair Dryer',
  'Iron',
  'Work Desk',
  'Wardrobe',
  'Geyser',
  'Attached Bathroom',
  'Mountain View',
  'Garden View',
  'Pool View',
  'Sea View',
];

export const LANGUAGES = [
  'English',
  'Hindi',
  'Marathi',
  'Tamil',
  'Telugu',
  'Kannada',
  'Malayalam',
  'Bengali',
  'Gujarati',
  'Punjabi',
];

export const ACCESSIBILITY_FEATURES = [
  'Wheelchair Accessible',
  'Braille Signage',
  'Accessible Bathroom',
  'Grab Rails',
  'Ramps',
  'Elevator',
  'Ground Floor Rooms',
];
